import { render, staticRenderFns } from "./EvaluacionProductividadCardComponent.vue?vue&type=template&id=d612d736"
import script from "./EvaluacionProductividadCardComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionProductividadCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports